import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import * as $ from 'jquery';
import { Grid, GridColumn as Column, GridCell } from '@progress/kendo-react-grid';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { fetchApi, JsonResponse } from '../../services/api';

type Props = RouteComponentProps<{
    childId: string;
 }>;

type State = {
    childId: number;
    accountId: number;
    charges: Charge[];
    isLoading: boolean;
    isSaving: boolean;
    validation: boolean;

    amount: number | null;
    comment: string;
    date: Date | null;
    Errors: JsonResponse;
}

export interface Charge {
    ChargeId: number;
    Amount: number;
    Comment: string;
    Date: Date;
}

class DateCell extends GridCell {
    render() {
        if (!this.props.field) return null;

        return (
            <td>{moment.utc(this.props.dataItem[this.props.field]).local().format("YYYY-MM-DD")}</td>
        );
    }
}

export default class ChildCharges extends React.Component<Props, State> {

    CommandCell: typeof GridCell;

    constructor(props: Props) {
        super(props);
        this.state = {
            childId: 0,
            accountId: 0,
            charges: [],
            isLoading: true,
            isSaving: false,
            validation: false,

            amount: 0,
            comment: '',
            date: new Date(),
            Errors: {
                Success: true,
                ErrorMessage: "",
            }
        };

        this.save = this.save.bind(this);
        this.getCharges = this.getCharges.bind(this);
        this.payments = this.payments.bind(this);
        const deleteCharge = this.deleteCharge.bind(this);

        class ReverseCell extends GridCell {
            render() {
                return (
                    <td><button type="button" className="btn btn-danger" onClick={() => deleteCharge(this.props.dataItem.ChargeId)}>Delete</button></td>
                );
            }
        }

        this.CommandCell = ReverseCell;
    }


    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.getCharges(childId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let childId = parseInt(nextProps.match.params.childId) || 0;

        if (this.state.charges && this.state.childId != childId) {
            this.getCharges(childId);
        }
    }

    public render() {
        return <div>
            <br/>
            <div className="row">
                <div className="col">
                    <h1>Charges</h1>
                </div>
                <div className="col">
                    <button type="button" className="btn btn-primary float-right" data-toggle="modal" data-target=".charges">Add Charge</button>
                    <button type="button" className="btn btn-secondary float-right" style={{ marginRight: 5 }} onClick={this.payments}>Payments</button>
                    <div id="chargeModal" className="modal fade charges" tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Add Charge</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                <div className="form-group">
                                        <NumericTextBox
                                            defaultValue={this.state.amount}
                                            format="c2"
                                            min={0}
                                            value={this.state.amount}
                                            onChange={(e) => this.setState({ amount: e.value })}
                                        />
                                        {this.state.validation && !this.state.amount && <p className="error-msg">Please enter Amount</p>}
                                    </div>
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Additional Charge Reason"
                                            value={this.state.comment}
                                            onChange={(e) => this.setState({ comment: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <DatePicker
                                            format="MM/dd/yyyy"
                                            formatPlaceholder="formatPattern"
                                            value={this.state.date}
                                            onChange={(e) => this.setState({ date: e.value })}
                                        />
                                        {this.state.validation && this.state.date === null && <p className="error-msg">Please enter Date</p>}
                                    </div>
                                    <button className="btn btn-primary" onClick={this.save}>Add Charge</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Grid data={this.state.charges} scrollable='none'>
                <Column field="Amount" title="Amount" format="{0:c}" filter="numeric" />
                <Column field="Comment" title="Comment" />
                <Column field="Date" title="Date" cell={DateCell} filter="date" />
                <Column field="Delete" title="Delete" cell={this.CommandCell} />
            </Grid>
        </div>
    }

    private getCharges(childId: number) {
        this.setState({ isLoading: true, childId });
        fetchApi(`api/Children/Charges/${childId}`)
            .then((data: { AccountID: number, Charges: Charge[] }) => {
                this.setState({ isLoading: false, charges: data.Charges, accountId: data.AccountID});
            });
    }

    private save() {

        if ( !this.state.amount || this.state.date === null) {
            this.setState({ validation: true })
            return;
        }

        if (this.state.isSaving) {
            return;
        }

        this.setState({ isSaving: true });

        const data = {
            Amount: this.state.amount,
            Comment: this.state.comment,
            Date: this.state.date
        }

        fetchApi(`api/Children/AddCharge/${this.state.childId}`, data, 'POST')
            .then(( Errors: JsonResponse ) => {
                this.setState({ Errors }, () => {

                    if(this.state.Errors.Success === false) {
                        alert(this.state.Errors.ErrorMessage);
                    }
                    else {
                        this.setState({ amount: 0, comment: '', validation: false });
                        this.getCharges(this.state.childId);
                        $("#chargeModal").modal('hide');
                    }
                })
            })
        this.setState({isSaving: false});
    }

    private deleteCharge(ChargeId: number) {
        if(confirm("Delete Charge?")) {
            fetchApi(`api/Children/DeleteCharge/${ChargeId}`, {} , 'Delete')
                .then(( Errors: JsonResponse ) => {
                    this.setState({ Errors }, () => {
                        if(this.state.Errors.Success === false) {
                            alert(this.state.Errors.ErrorMessage);
                        }
                        else {
                            this.getCharges(this.state.childId);
                        }
                    })

                });
        }
    }

    private payments() {
        this.props.history.push(`/accounts/${this.state.accountId}/payments`)
    }
}
